import React, { useEffect, useState, useRef } from 'react';
import { Rnd } from 'react-rnd';

const LOCAL_STORAGE_KEY = 'a4_editor_elements';
const GRID_SIZE = 10;

const TestDraggableElements = () => {
  const [elements, setElements] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [bgImage, setBgImage] = useState(null);
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, id: null });
  const editorRef = useRef();

  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) setElements(JSON.parse(saved));
    else {
      setElements([
        {
          id: 'text1',
          x: 50,
          y: 50,
          width: 300,
          height: 60,
          type: 'text',
          color: '#000000',
        },
        {
          id: 'image1',
          x: 400,
          y: 50,
          width: 120,
          height: 80,
          type: 'image',
          src: '/iusevolutione/assets/img/iusevolutione/logoWithTitle.png',
        },
        {
          id: 'table1',
          x: 50,
          y: 150,
          width: 300,
          height: 100,
          type: 'table',
        },
        {
          id: 'div1',
          x: 400,
          y: 200,
          width: 200,
          height: 100,
          type: 'div',
        },
      ]);
    }
    const handleClickOutside = () => setContextMenu({ visible: false, x: 0, y: 0, id: null });
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, []);

  const updateElement = (id, newProps) => {
    const updated = elements.map((el) => (el.id === id ? { ...el, ...newProps } : el));
    setElements(updated);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
  };

  const handleSelect = (id) => setSelectedId(id);

  const sendToBack = (id) => {
    const index = elements.findIndex((el) => el.id === id);
    if (index > -1) {
      const reordered = [...elements];
      const [el] = reordered.splice(index, 1);
      reordered.unshift(el);
      setElements(reordered);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(reordered));
    }
  };

  const handlePrint = () => {
    const original = document.body.innerHTML;
    document.body.innerHTML = editorRef.current.innerHTML;
    window.print();
    window.location.reload();
    document.body.innerHTML = original;
  };

  const handleCancel = () => window.location.reload();

  const snapToGrid = (value) => Math.round(value / GRID_SIZE) * GRID_SIZE;

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ marginBottom: 10 }}>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files[0];
            const url = URL.createObjectURL(file);
            setBgImage(url);
          }}
        />
        Upload Background

        {selectedId &&
          elements.find((el) => el.id === selectedId)?.type === 'text' && (
            <input
              type="color"
              value={elements.find((el) => el.id === selectedId).color || '#000000'}
              onChange={(e) => updateElement(selectedId, { color: e.target.value })}
              style={{ marginLeft: 10 }}
            />
          )}

        

              <button
                  onClick={() => {
                      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(elements));
                      setSelectedId(null); // 👈 Hide rulers after saving
                  }} style={{ marginLeft: 10 }}>
                  Save
              </button>


        <button onClick={handleCancel} style={{ marginLeft: 5 }}>
          Cancel
        </button>
        <button onClick={handlePrint} style={{ marginLeft: 5 }}>
          Print
        </button>
      </div>

      {contextMenu.visible && (
        <ul
          style={{
            position: 'absolute',
            top: contextMenu.y,
            left: contextMenu.x,
            listStyle: 'none',
            margin: 0,
            padding: '4px 8px',
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            zIndex: 9999,
          }}
        >
          <li
            style={{ padding: '4px 0', cursor: 'pointer' }}
            onClick={() => {
              sendToBack(contextMenu.id);
              setContextMenu({ visible: false, x: 0, y: 0, id: null });
            }}
          >
            Send to Back
          </li>
        </ul>
      )}

      <div
        ref={editorRef}
        style={{
          width: '794px',
          height: '1123px',
          border: '1px solid black',
          margin: 'auto',
          position: 'relative',
          backgroundColor: 'white',
          backgroundImage: bgImage ? `url(${bgImage})` : undefined,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {selectedId &&
          elements.map((refEl) => {
            if (refEl.id === selectedId) return null;
            const sel = elements.find((el) => el.id === selectedId);
            return (
              <React.Fragment key={`guides-${refEl.id}`}>
                <div
                  style={{
                    position: 'absolute',
                    top: sel.y,
                    left: refEl.x,
                    width: 1,
                    height: '100%',
                    background: '#00f3',
                    zIndex: 1,
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    left: sel.x,
                    top: refEl.y,
                    height: 1,
                    width: '100%',
                    background: '#f003',
                    zIndex: 1,
                  }}
                />
              </React.Fragment>
            );
          })}

        {elements.map((el, index) => (
          <Rnd
            key={el.id}
            default={{
              x: el.x,
              y: el.y,
              width: el.width,
              height: el.height,
            }}
            bounds="parent"
            style={{
              zIndex: index + 2,
              border: el.id === selectedId ? '2px dashed #007bff' : 'none',
              padding: 4,
              cursor: 'move',
              backgroundColor: el.type === 'div' ? '#f5f5f5' : undefined,
            }}
            onClick={() => handleSelect(el.id)}
            onContextMenu={(e) => {
              e.preventDefault();
              setContextMenu({ visible: true, x: e.pageX, y: e.pageY, id: el.id });
            }}
            onDragStop={(e, d) =>
              updateElement(el.id, {
                x: snapToGrid(d.x),
                y: snapToGrid(d.y),
              })
            }
            onResizeStop={(e, dir, ref, delta, pos) =>
              updateElement(el.id, {
                width: snapToGrid(ref.offsetWidth),
                height: snapToGrid(ref.offsetHeight),
                x: snapToGrid(pos.x),
                y: snapToGrid(pos.y),
              })
            }
          >
            {el.type === 'text' && (
              <div style={{ fontWeight: 'bold', color: el.color || '#000' }}>
                <span>Republic of the Philippines )</span>
                <br />
                <span>City/Municipality of ) S.S.</span>
              </div>
            )}

            {el.type === 'image' && (
              <img
                src={el.src}
                alt="Logo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            )}

            {el.type === 'table' && (
              <table className="table table-bordered w-100 h-100" style={{ width: '100%', height: '100%' }}>
                <tbody>
                  <tr>
                    <td>Row 1</td>
                    <td>Row 1</td>
                  </tr>
                  <tr>
                    <td>Row 2</td>
                    <td>Row 2</td>
                  </tr>
                </tbody>
              </table>
            )}

            {el.type === 'div' && (
              <div style={{ width: '100%', height: '100%', padding: 10 }}>
                Custom content here
              </div>
            )}
          </Rnd>
        ))}
      </div>
    </div>
  );
};

export default TestDraggableElements;